"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        color: theme.grey1,
        borderTopWidth: 1,
        borderTopStyle: 'solid',
        borderTopColor: theme.grey5,
        backgroundColor: 'transparent',
        '&:first-child': {
            borderTopWidth: 0
        },
        '&:hover': {
            backgroundColor: theme.indigo3,
            color: theme.white1,
            borderTopColor: theme.indigo3,
            '& + *': {
                borderTopColor: theme.indigo3
            }
        }
    },
    button: {
        appearance: 'none',
        backgroundColor: 'transparent',
        flexGrow: 1,
        boxSizing: 'border-box',
        height: 44,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 14,
        paddingRight: 14,
        borderWidth: 0,
        cursor: 'pointer',
        outline: 'none',
        color: 'inherit',
        '&:focus:not(:hover)': {
            color: theme.indigo3
        }
    },
    buttonIcon: {
        display: 'block',
        flexShrink: 0,
        width: 20,
        height: 20,
        marginRight: 14,
        '& > svg': {
            display: 'block',
            width: '100%',
            height: 'auto'
        }
    },
    buttonLabel: {
        display: 'block',
        flexGrow: 1,
        fontSize: 14,
        fontWeight: 400
    }
});
//# sourceMappingURL=pulldown.menu.item.style.js.map